// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabImage[data-v-11846d5f] {\n  width: 36px;\n  height: px;\n}", ""]);
// Exports
module.exports = exports;
